<template>
  <div class="hotoliver">
    <div class="hotoliver-content">
      <div class="title-box">
        <div class="title">
          {{ title }}
        </div>
        <a v-if="url.indexOf('https') != -1" :href="url">
          <div class="more">
            更多
            <van-icon name="arrow"/>
          </div>
        </a>
        <router-link v-else-if="url.indexOf('https') == -1" :to="url">
          <div class="more">
            更多
            <van-icon name="arrow"/>
          </div>
        </router-link>
        <div v-else class="more">
          更多
          <van-icon name="arrow"/>
        </div>
      </div>
      <div class="hotoliverList">
        <dl
            v-for="(item, index) in hotoliverList"
            :key="index"
            class="articleList"
        >
          <dd>
            <p @click="toArticle(item, index)">{{ item.title }}</p>
            <div :data="JSON.stringify(item)" :index="index" class="counts">
              <div>
                <img alt="" src="../../assets/images/nweHome/lookIcon.png" />
                <span>{{ fomatterNum(item.watchNum) }}</span>
              </div>
              <div
                  @click.stop="loginFlag ? collectClick(item, index) : toLogin()"
              >
                <i :class="flags[index] ? 'collected' : 'collect'"> </i>
                <span>{{ fomatterNum(item.collectNum) }}</span>
              </div>
              <div>
                <img alt="" src="../../assets/images/nweHome/review.png" />
                <span>{{ fomatterNum(item.commentNum) }}</span>
              </div>
            </div>
          </dd>
          <dt>
            <img :src="item.coverUrl" alt="" @click="toArticle(item, index)" />
          </dt>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import { fomatterNum, getCookie } from '@/assets/js/common.js'
import { BuiedPointClick_Fn } from '@/assets/js/BuriedPointEvent.js'
import { Exposurer_home_baby } from '@/assets/js/Exposure'
import { commonOperationEvent } from '@/utils/commonApiList'


export default {
  name: 'hotOliver',
  props: {
    title: {
      type: String,
      require: true,
    },
    url: {
      type: String,
      require: true,
    },
    tagId: {
      type: String,
    },
    curMonth: {
      type: Number,
    },
    loginFlag: {
      // 是否登录
      type: Boolean,
    },
    babyCurrentNum: {
      type: Number,
    },
  },
  data() {
    return {
      //热门好文列表
      hotoliverList: [],
      userInfo: null, //用户信息
      flags: {
        0: false,
        1: false,
        2: false,
      },
      requestId: '',
    }
  },
  components: {},
  watch: {
    babyCurrentNum() {
      this.getBabyRecommend()
    },
    $route() {
      let hotStatus = JSON.parse(localStorage.getItem('hotStatus')) || []
      hotStatus.forEach((item, index) => {
        if (this.flags[index] != item.state) {
          this.$nextTick(function () {
            this.flags[index] = item.state;
          })
        }
      })
    },
  },
  async mounted() {
    this.getBabyRecommend()
  },
  methods: {
    getBabyRecommend() {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      let babybirth = '', currentBaby = '';
      var babyInfo = JSON.parse(localStorage.getItem("babyInfo"));
      if (babyInfo) {
        currentBaby = getCookie("babyNum");
        const currentBabyInfo = babyInfo.filter((item) => {
          return item.num == currentBaby
        })
        babybirth = currentBabyInfo[0]?.birth;
      }
      // 智能推荐
        console.log('开启智能推荐')
        const date = Date.parse(new Date())
        let unionid = getCookie('xmh_unionid')
        const requestId = this.$md5(date + unionid)
        this.requestId = requestId
        // 获取当前胎次与当前胎次宝宝的生日--开始
        let params = {
          babyBirthDay: babybirth,
          tagId: Number(this.tagId),
          crmId: this.userInfo && this.userInfo.crm_id || getCookie("xmh_openid") || getCookie("xmh_unionid"),
        }
        this.$http.post(
          '/content/flow/hotEssayList',
          {},
          params,
          (res) => {
            if (res.code === 200) {
              this.hotoliverList = res.data || []
              let hotStatus = []
              this.hotoliverList.forEach((item, index) => {
                this.flags[index] = item.collectState
                hotStatus.push({ id: item.id, state: item.collectState })
              })
              localStorage.setItem('hotStatus', JSON.stringify(hotStatus))
              //埋点
              setTimeout(() => {
                Exposurer_home_baby.observe('.counts', false, {
                  requestId: requestId,
                  name: '星妈会首页',
                })
              }, 1000)
            }
          },
          null, 'lucky'
        )
    },
    //处理埋点参数
    getParams(item, index) {
      return {
        traceid: item.traceId,
        content_id: item.pkContent,
        content_title: item.title,
        tab_name:
            item.tagName == null || item.tagName == '' ? '' : item.tagName,
        page_name: this.$route.meta.title,
        author: '',
        itemSetId: this.isRecommendSwitch == '0' ? item.itemSetId : '',
        sceneId: this.isRecommendSwitch == '0' ? item.sceneId : '',
        context: this.isRecommendSwitch == '0' ? item.context : '',
        requestId: this.isRecommendSwitch == '0' ? this.requestId : '',
        position: index,
      }
    },
    //文章点击
    toArticle(item, index) {
      //埋点
      BuiedPointClick_Fn('NewsClick', {
        xmhh5_articletitle_view_pagename: this.$route.meta.title,
        xmhh5_article_title: item.title,
      })
      var that = this
      setTimeout(function () {
        that.$router.push({
          path: '/baby/detail/' + item.id + '?source=home',
        })
      }, 200)
    },
    //点击收藏按钮
    collectClick(item, index) {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
      let hotstatus = JSON.parse(localStorage.getItem('hotStatus'))
      if (this.flags[index]) {
        //取消收藏
        commonOperationEvent({
          crmId: this.userInfo.crm_id,
          itemId: item.id,
          type: 1,
          actionType: 1,
        }).then((res)=>{
          if (res.code == 200) {
            //刷新列表
            // this.getBabyRecommend();
            this.flags[index] = false
            hotstatus[index].state = false
            localStorage.setItem('hotStatus', JSON.stringify(hotstatus))
          }
        })
      } else {
        //收藏
        commonOperationEvent({
          crmId: this.userInfo.crm_id,
          itemId: item.id,
          type: 0,
          actionType: 1,
        }).then((res)=>{
          if (res.code == 200) {
            //刷新列表
            // this.getBabyRecommend();
            this.taskFinishCollect(item.id, index)
          }
        })
      }
    },
    // 完成收藏任务
    taskFinishCollect: function (id, index) {
      if (this.userInfo) {
        let hotstatus = JSON.parse(localStorage.getItem('hotStatus'))
        this.flags[index] = true
        hotstatus[index].state = true
        localStorage.setItem('hotStatus', JSON.stringify(hotstatus))
        this.$toast({
          duration: 2000,
          message: '收藏成功，和千万星妈一起学习',
          context: this,
        })
      }
    },

    // 跳转登陆页面
    toLogin() {
      this.$emit('goLogin')
    },
    fomatterNum,
  },
}
</script>

<style lang="less" scoped>
.hotoliver {
  margin-top: 13px;
  padding: 0 16px;

  .hotoliver-content {
    background: #fff;
    border-radius: 8px;

    .title-box {
      height: 45px;
      padding: 0 12px;
      padding: 0 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #eee;

      .title {
        font-size: @indexFontSize16;
        font-weight: 500;
        color: #3d3d3d;
      }

      a {
        color: #999999;

        .more {
          display: flex;
          align-items: center;

          .van-icon {
            font-size: @indexFontSize12;
          }
        }
      }

      .more {
        display: flex;
        align-items: center;
        height: 16px;

        .van-icon {
          font-size: @indexFontSize12;
        }
      }
    }

    .hotoliverList {
      padding: 0 12px;
    }

    dl {
      display: flex;
      padding: 15px 0;
      border-bottom: 1px solid #eee;

      dt {
        width: 80px;
        height: 60px;

        img {
          width: 100%;
          height: 100%;
          border-radius: 8px;
        }
      }

      dd {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-right: 19px;

        p {
          font-size: @indexFontSize14;
          font-weight: 500;
          color: #3d3d3d;
          line-height: 20px;
          width: 100%;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }

        .counts {
          display: flex;
          font-size: 11px;
          color: #888888;
          justify-content: space-between;

          div {
            display: flex;
            align-items: center;

            img {
              width: 12px;
              height: 12px;
              margin-right: 2px;
            }

            i {
              width: 12px;
              height: 12px;
              display: inline-block;
              margin-right: 2px;
            }

            .collect {
              background: url(../../assets/images/nweHome/collect.png) no-repeat;
              background-size: cover;
            }

            .collected {
              background: url(../../assets/images/nweHome/collected.png) no-repeat;
              background-size: cover;
            }
          }
        }
      }
    }

    dl:last-child {
      border: none;
    }
  }
}
</style>
